import SelectorEngine from '../../../utils/dom/selector-engine';
import EventHandler from '../../../utils/dom/event-handler';
import Modal from '../../../components/Modal';
import Manipulator from '../../../utils/dom/manipulator';
import Request from '../../../utils/request';
import { startLoadingAnimation, stopLoadingAnimation } from '../../../utils/dom/loading';
import { ImageUpload } from '../../../components/ImageUpload';

class OfficialsEditProfilePhoto {
	constructor() {
		this.status = undefined;
		this.profileImage = '';
		this._container = SelectorEngine.findOne('.js-edit-officials-details-profile-photo');

		if (this._container) {
			this.init();
		}
	}

	init() {
		this._exitModal = new Modal(SelectorEngine.findOne('#officials-details-profile-photo-exit', this._container ), {});

		this._cancelCta = SelectorEngine.findOne('.lta-officials-details__edit-profile-photo-back', this._container );
		this._cancelCta.addEventListener('click', () => this._exitModal.show());

		const popupCancel = SelectorEngine.findOne('.lta-officials-details__edit-profile-photo-continue', this._container );
		popupCancel.addEventListener('click', () => this._exitModal.hide());

		const popupContinue = SelectorEngine.findOne('.lta-officials-details__edit-profile-photo-exit', this._container );
		popupContinue.addEventListener('click', (event) => this.backToUrl(event));

		this.hideProfilePhoto = SelectorEngine.findOne('.hide-profile-photo', this._container);
		const initialStatus = this.hideProfilePhoto.querySelector('.lta-toggle--checkbox').checked;
		this.status = initialStatus ? initialStatus : false;

		const imageUpload = SelectorEngine.findOne('#lta-upload-image', this._container);
		EventHandler.on(imageUpload, 'change', (event) => {
			this.saveImagefile();
		});

		this._errorContainer = SelectorEngine.findOne('.lta-edit-profile-photo-error-container', this._container);
		this._errorText = SelectorEngine.findOne('.error-text', this._errorContainer);
		this._closeErrorSnackBar = SelectorEngine.findOne('.js-dismiss-error', this._errorContainer);

		this._closeErrorSnackBar.addEventListener('click', () => {
			this._errorContainer.classList.add('u-hidden');
		});

		this._saveCta = SelectorEngine.findOne('.save-image-cta', this._container);
		this._saveCta.addEventListener('click', async (event) => {
			const element = SelectorEngine.findOne('#lta-image-upload-form', this._container);
			const imageUploadComponent = ImageUpload.getOrCreateInstance(element);
			try {
				await imageUploadComponent.cropHandler(() => this.triggerSubmit(event));
			} catch (error) {
				console.error(error)
			}
		});

		EventHandler.on(window, 'toggleStatus', (event) => {
			this.status = event.detail.status;
		});
	}

	saveImagefile() {
		const avatarImage = SelectorEngine.findOne('#lta-upload-image', this._container).files[0];
		if (!!avatarImage) {
			if (Number(avatarImage.size) < 5_242_880) {
				this.profileImage = avatarImage;
			} else {
				this._errorContainer.classList.remove('u-hidden');
				this._errorText.innerHTML = 'This file size exceeds the maximum limit. Please select a file under 5mb';
				this._errorContainer.scrollIntoView();
			}
		}
	}

	async triggerSubmit(event) {
		event.preventDefault();
		startLoadingAnimation(true);
		const formData = new FormData();

		const finalData = Object.assign(
			{},
			{
				profilePhotoVisibility: this.status
			}
		);

		this.saveImagefile();
		formData.append('json_profilephoto', JSON.stringify(finalData));

		this.profileImage && formData.append(`attachment_profilephoto`, this.profileImage);

		try {
			const url = `/api/officials/updatephoto`;
			const responseData = await Request.postFormData(url, formData);

			const { success } = responseData;
			if (success) {
				const redirectUrl = Manipulator.getDataAttribute(this._container, 'redirect-url');
				window.location.href = redirectUrl;
			} else {
				this._errorContainer.classList.remove('u-hidden');
				this._errorText.innerHTML = Manipulator.getDataAttribute(this._container, 'api-failed-error');
			}
		} catch {
			this._errorContainer.classList.remove('u-hidden');
			this._errorText.innerHTML = Manipulator.getDataAttribute(this._container, 'api-failed-error');
			this._errorContainer.scrollIntoView();
		} finally {
			stopLoadingAnimation();
		}
	}

	backToUrl(event, redirectUrl) {
		const rootUrl = window.location.origin;
		const url = redirectUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}
}

const globalEditProfilePhoto = new OfficialsEditProfilePhoto();

export default globalEditProfilePhoto;
